import { BindAll } from 'lodash-decorators'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiCourse, EnumApiOrder } from '@xt/client/api'
import { UserCourseStudyProgress } from '@xt/client/types/course.d'
import { action, observable } from 'mobx'

@BindAll()
export class StatisticsData {
  constructor() {}
  // 添加书同入群，第一张图
  @observable assistantUrl: string = ''
  // 统计数据
  @observable studyProgress: UserCourseStudyProgress | null = null

  // 查询书童入群图
  async getAssistantUrl(productId: string) {
    console.warn('~~~~~~~getAssistantUrl1', productId)

    const [err4, assistant] = await $service<Array<{ assistantUrl: string }>>({
      url: EnumApiOrder.AssistantUrl,
      data: {
        productId
      }
    })

    if (err4) throw err4

    if (Array.isArray(assistant) && assistant.length > 0) {
      this.setAssistantUrl(assistant[0].assistantUrl)
    } else {
      // 清空
      this.setAssistantUrl('')
    }
  }

  // 课程详情页获取用户学习数据
  async getUserLearnData(courseId: string) {
    const [err, data] = await $service<UserCourseStudyProgress>({
      url: EnumApiCourse.StudyProgress,
      data: { id: courseId }
    })
    if (err) {
      throw new Error('网络开小差了~')
    }
    this.setStatistics(data)
  }

  @action
  setAssistantUrl(assistantUrl: string) {
    this.assistantUrl = assistantUrl
  }

  @action
  setStatistics(data: UserCourseStudyProgress) {
    this.studyProgress = data
  }

  // 重置自身状态的方法
  @action
  reset() {
    this.assistantUrl = ''
    this.studyProgress = null
  }
}
